import {DESIGNATION, EMPLOYEES, GET_ALL_LOCATIONS} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {
    DepartmentFilterMixin,
    DesignationFilterMixin,
    EmploymentStatusFilterMixin,
    RoleFilterMixin,
    WorkingShiftFilterMixin
} from "./FilterMixin";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                cardViewComponent: 'app-location-card-view',
                name: this.$allLabel('locations'),
                url: GET_ALL_LOCATIONS,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('location'),
                        type: 'custom-html',
                        key: 'name',
                        isVisible: true,
                        modifier: (location) => {
                            return location ? location: '-';
                        }
                    },
                    {
                        title: this.$t('latitude'),
                        type: 'custom-html',
                        key: 'latitude',
                        isVisible: true,
                        modifier: (latitude) => {
                            return latitude ?? '-';
                        }
                    },
                    {
                        title: this.$t('longitude'),
                        type: 'custom-html',
                        key: 'longitude',
                        isVisible: true,
                        modifier: (longitude) => {
                            return longitude ?? '-';
                        }
                    },
                    {
                        title: this.$t('radius'),
                        type: 'custom-html',
                        key: 'radius',
                        isVisible: true,
                        modifier: (radius) => {
                            return radius ?? '-';
                        }
                    },
                    {
                        title: this.$t('alias'),
                        type: 'custom-html',
                        key: 'alias',
                        isVisible: true,
                        modifier: (alias) => {
                            return alias ?? '-';
                        }
                    },
                    {
                        title: this.$t('address'),
                        type: 'custom-html',
                        key: 'address',
                        isVisible: true,
                        modifier: (address) => {
                            return address ?? '-';
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        // url: GET_ALL_LOCATIONS,
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_locations') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        url: GET_ALL_LOCATIONS,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'delete',
                        modifier: row => {
                            return this.$can('update_locations') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    }
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {
            this.promptIcon = action.icon;
            this.employeeId = row.id;
            this.modalClass = action.modalClass;

            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            // if (action.key === 'edit') {
            //     this.selectedUrl = `${action.url}/${row.id}`;
            //     this.isModalActive = true;
            // }
        },
    }
}